import React from 'react';
import { useClickEvent } from 'hooks/use-internal-clicks.js';
import { useExternalControl } from 'hooks/use-external-control.js';
import { BgLayer } from '../bg-layer';
import styles from './image.module.css';
import { useSetDataAttrs } from '#/hooks/index.js';

export default function Image({ desc }) {
  const { url, backgrounds } = desc;

  return (
    <ImageWrapper desc={desc}>
      <div role="outline-decorator" />
      <img src={url} alt="" />
      {backgrounds.map((background) => {
        return <BgLayer key={background.id} desc={background} />;
      })}
    </ImageWrapper>
  );
}

function ImageWrapper({ desc, children }) {
  const ref = useExternalControl();

  const { id, link, autoFocus, className, isMainTarget, isClickable } = desc;
  /**
   * @type {React.MutableRefObject<HTMLAnchorElement>}
   */
  const onClick = useClickEvent(desc);
  const appliedClassName = `${styles.imageContainer} ${className ?? ''}`;

  useSetDataAttrs(ref, desc.dataset);

  if (isClickable) {
    return (
      <a
        ref={ref}
        href={link}
        id={id}
        role="img"
        onClick={onClick}
        className={appliedClassName}
        data-auto-focus={autoFocus}
        data-main-target={isMainTarget || undefined}
      >
        {children}
      </a>
    );
  }

  return (
    <div id={id} className={appliedClassName}>
      {children}
    </div>
  );
}
